export enum ButtonWithDropdownTypeEnum {
  Link = 'link',
  Button = 'button',
}
